import React from "react";
import { Button, Modal } from "flowbite-react";
const ErrorPopup = ({
  openModal,
  handleClosePopup,
  warningText,
  size = "md",
  buttonPosition = "left",
}) => {
  return (
    <div>
      <Modal show={openModal} size={size} onClose={handleClosePopup} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <svg
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
              class="mx-auto mb-4 h-14 w-14 text-red-600 dark:text-gray-200"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>

            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {warningText}
            </h3>
            <div
              className={`flex gap-4 ${
                buttonPosition === "center" ? "justify-center" : ""
              }`}
            >
              <Button color="gray" onClick={handleClosePopup}>
                Close
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ErrorPopup;
